import React from 'react';
import { tone } from './tones';

/** Label ··· value row for breakdowns inside cards. */
export default function MetricRow({ label, value, tone: toneName, dot = false }) {
    return (
        <div className="flex items-center justify-between py-1.5">
            <span className="flex items-center gap-2 text-sm text-surface-600">
                {dot && <span className={`h-2 w-2 rounded-full ${tone(toneName).solid}`} />}
                {label}
            </span>
            <span className={`text-sm font-semibold tabular-nums ${toneName && !dot ? tone(toneName).text : 'text-surface-900'}`}>{value}</span>
        </div>
    );
}
